import { common } from './common.icons';

export const IconRibbon = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-ribbon ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M11.9963 7.32923L5.595 4.05998C3.72 3.10748 1.5 4.46498 1.5 6.56498V12.55C1.5 14.65 3.72 16.015 5.595 15.055L6.1125 14.791L3.9825 20.3132C3.81 20.7535 4.2675 21.178 4.695 20.9845L6.39 20.224C6.66 20.1047 6.975 20.224 7.095 20.4925L7.8375 22.1845C8.025 22.6165 8.6475 22.6015 8.82 22.162L11.9925 13.9285L15.165 22.162C15.3375 22.6015 15.96 22.6165 16.1475 22.1845L16.89 20.4925C17.01 20.224 17.325 20.1047 17.595 20.224L19.29 20.9845C19.7175 21.178 20.175 20.7535 20.0025 20.3132L17.871 14.7857L18.3975 15.0557C20.2725 16.0157 22.4925 14.6507 22.4925 12.5507V6.56573C22.4925 4.46573 20.2725 3.10823 18.3975 4.06073L11.9963 7.32923Z"
        fill="#6D3FE6"
      />
      <path
        d="M10.6911 4.5H13.3101C14.2454 4.5 15.0006 5.2485 15.0006 6.1575V12.4357L18.4056 10.6972C20.1756 9.79725 22.2606 10.9673 22.4781 12.8798C22.2681 14.7923 20.1831 15.9698 18.4056 15.0623L14.8619 13.2533C14.7278 13.5522 14.5096 13.8056 14.2339 13.9826C13.9582 14.1596 13.637 14.2525 13.3094 14.25H10.6919C9.99438 14.25 9.39738 13.839 9.13788 13.2502L5.58812 15.0623C3.81813 15.9698 1.72563 14.7923 1.51562 12.8798C1.72563 10.9673 3.81063 9.78975 5.58812 10.6972L9.00062 12.4395V6.1575C9.00062 5.24025 9.75587 4.5 10.6911 4.5Z"
        fill="#5728D3"
      />
    </svg>
  );
};
